import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";
const WareHouseManagement = () => {
  const [selectedCountry, setSelectedCountry] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [warehouseData, setWarehouseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [addressContent, setAddressContent] = useState("");
  const getWarehouseDetails = async () => {
    setLoading(true);
    try {
      let body = { from, to };
      let response = await axios.post(`${BaseUrl}/get-warehouse-details`, body);
      if (response.status === 200) {
        setWarehouseData(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWarehouseDetails();
  }, [from, to]);

  const handleCountryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCountry(selectedValue);

    const countryMap = {
      "CHINA-INDIA": { from: "CHINA", to: "INDIA" },
      "CHINA-CANADA": { from: "CHINA", to: "CANADA" },
      "INDIA-CANADA": { from: "INDIA", to: "CANADA" },
      "INDIA-USA": { from: "INDIA", to: "USA" },
    };

    if (selectedValue === "") {
      setFrom("");
      setTo("");
    } else if (countryMap[selectedValue]) {
      setFrom(countryMap[selectedValue].from);
      setTo(countryMap[selectedValue].to);
    }
  };
  const tabOptions = [
    { value: "", label: "Select Country" },
    { value: "CHINA-INDIA", label: "CHINA - INDIA" },
    { value: "CHINA-CANADA", label: "CHINA - CANADA" },
    { value: "INDIA-CANADA", label: "INDIA - CANADA" },
    { value: "INDIA-USA", label: "INDIA - USA" },
  ];

  return (
    <MasterLayout>
      <Breadcrumb title="warehouses" />
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header py-16 pb-0 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex align-items-center flex-wrap justify-content-between">
            <h6 className="text-lg mb-0">Warehouses</h6>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div className="position-relative" style={{ minWidth: "180px" }}>
                <Icon
                  icon="solar:alt-arrow-down-outline"
                  className="position-absolute"
                  style={{
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6c757d",
                    zIndex: 1,
                  }}
                />

                <select
                  className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                  style={{
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  {tabOptions.map((tab) => (
                    <option key={tab.value} value={tab.value}>
                      {tab.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="card-body">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "calc(100vh - 300px)",
                  width: "100%",
                  background: "transparent",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: "#243E85",
                    width: "3rem",
                    height: "3rem",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : warehouseData.length === 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "200px",
                  width: "100%",
                  fontSize: "1.2rem",
                  color: "#243E85",
                  fontWeight: 500,
                }}
              >
                No warehouses found.
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table basic-border-table mb-0">
                  <thead>
                    <tr>
                      <th>Warehouse Address</th>
                      {!(from && to) && <th>Route (From → To)</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {warehouseData?.map((items, index) => (
                      <tr key={index}>
                        <td>
                          {items?.address ? (
                            items.address.length > 40 ? (
                              <>
                                <span>
                                  {items.address.slice(0, 40) + "..."}
                                </span>
                                <button
                                  className="btn btn-link  p-0 ms-2"
                                  style={{ color: "#243E85" }}
                                  onClick={() => {
                                    setAddressContent(items.address);
                                    setShowAddressModal(true);
                                  }}
                                >
                                  View more
                                </button>
                              </>
                            ) : (
                              <span>{items.address}</span>
                            )
                          ) : (
                            <span className="text-muted">
                              No address provided
                            </span>
                          )}
                        </td>
                        {!(from && to) && (
                          <td>{items.from + " -To- " + items.to}</td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAddressModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div className="card" style={{ width: "90%", maxWidth: 600 }}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h6 className="mb-0">Warehouse Address</h6>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowAddressModal(false)}
              >
                Close
              </button>
            </div>
            <div className="card-body">
              {addressContent ? (
                <p style={{ whiteSpace: "pre-wrap" }}>{addressContent}</p>
              ) : (
                <p className="text-muted">No address provided</p>
              )}
            </div>
          </div>
        </div>
      )}
    </MasterLayout>
  );
};

export default WareHouseManagement;
